import { ThemeOptions } from '@nelnet/unifi-components-react';

const customTypographyThemeOptions = {
  themeName: 'Custom Typography',
  palette: {
    primary: {},
    secondary: {},
  },
  typography: {
    fontFamily: [
      '"Roboto"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    h1: {
      fontSize: '2.25rem',
      letterSpacing: '0',
      lineHeight: '1.15',
    },
    h2: {
      fontSize: '1.75rem',
      fontWeight: 300,
      letterSpacing: '0',
      lineHeight: '1.15',
    },
    h3: {
      fontSize: '1.35rem',
      lineHeight: '1.15',
    },
    h4: {
      fontSize: '1.125rem',
    },
    h5: {
      fontSize: '1rem',
    },
    h6: {
      fontSize: '.9rem',
      fontWeight: 400,
    },
    paragraph: {},
    body1: {
      fontSize: '1.125rem',
      lineHeight: '1.5',
      letterSpacing: '0',
    },
    body2: {
      fontSize: '1rem',
      lineHeight: '1.3',
      letterSpacing: '0',
    },
    subtitle1: {
      fontSize: '1.25rem',
      lineHeight: '1.3',
    },
    subtitle2: {
      fontSize: '.9rem',
    },
    caption: {
      fontSize: '.875rem',
      letterSpacing: '0.03em',
    },
    overline: {
      fontSize: '.875rem',
      lineHeight: '1.4',
      letterSpacing: '.17em',
    },
    button: {
      fontWeight: 600,
      letterSpacing: '0.125em',
    },
  },
  overrides: {
    MuiTypography: {
      gutterBottom: {
        marginBottom: '0.5em',
      },
    },
  },
} as ThemeOptions;

export default customTypographyThemeOptions;
